import * as yup from 'yup';
import Validations from 'enums/schemaValidations/validations.enum';

const validationSchema = yup.object().shape({
  name: yup.string().required(Validations.RequiredName),
  description: yup.string().required(Validations.RequiredDescription),
  source: yup.string().nullable().required(Validations.RequiredSource),
  type: yup.string().nullable().required(Validations.RequiredType),
  merchantNetwork: yup
    .string()
    .nullable()
    .required(Validations.RequiredNetwork),
  acceptedCards: yup
    .array()
    .nullable()
    .required(Validations.RequiredAcceptedCards),
  qualifiedIssuer: yup
    .array()
    .nullable()
    .required(Validations.RequiredQualifiedIssuers),
  category: yup.string().nullable().required(Validations.RequiredCategory),
  websiteURL: yup.string().url().required(Validations.RequiredWebsiteURL),
  imgUrl: yup.string().url().required(Validations.RequiredImgURL),
  fraudWarningAmountInCents: yup
    .number()
    .transform((value) => (Number.isNaN(value) ? undefined : value))
    .required(Validations.RequiredFraudWarning),
});

export default validationSchema;
